import { render, staticRenderFns } from "./MaterialTabs.vue?vue&type=template&id=69e4acfe&"
import script from "./MaterialTabs.vue?vue&type=script&lang=js&"
export * from "./MaterialTabs.vue?vue&type=script&lang=js&"
import style0 from "./MaterialTabs.vue?vue&type=style&index=0&id=69e4acfe&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports